import { observer } from 'mobx-react';
import * as React from 'react';
import { T } from '../../../../Translations';

interface Props {
  participantCount: number;
}

const Count: React.FC<Props> = ({ participantCount }) => (
  <div className="w-[130px]">
    <T kind="{{count}} item selected" count={participantCount} />
  </div>
);

export default observer(Count);
